// Port of api/fuel/app/classes/filter/search/games/rules/query/first_played.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'first_played',
	field: function() { return 'MIN(p.play_date)' }
})
